import { image } from '../../lib/format';

export const exampleProfileState = {
  creator: {
    displayName: 'Cynthia Tang',
    username: 'cynnthiamakes',
    headline: 'Singapore lifestyle, beauty, and cafe creator making relatable content for Gen Z audiences.',
    bio: 'I create beauty, lifestyle, and cafe content designed to feel useful, personal, and easy to relate to.',
    niches: ['Beauty', 'Lifestyle', 'Cafes', 'UGC'],
    creatorTypes: ['Content creator', 'UGC creator'],
    location: 'Singapore',
    languages: ['English', 'Mandarin'],
    availability: 'Available for collaborations',
    contactEmail: 'hello@cynthiatang.co',
    contactInfo: 'DM me on Instagram @cynnthiamakes or email hello@cynthiatang.co — I usually reply within 2 days.',
    avatarUrl: '/profile_pic_female_1.jpeg',
    coverUrl: '/mock_banner_1.jpeg',
  },
  socials: [
    {
      id: 'soc-instagram',
      platform: 'Instagram',
      handle: '@cynnthiamakes',
      followers: 8400,
      engagement: 5.2,
      stats: {
        genderBreakdown: [
          { category: 'Female', value: 78 },
          { category: 'Male', value: 22 },
        ],
        ageBreakdown: [
          { category: '18-24', value: 38 },
          { category: '25-34', value: 41 },
          { category: '35-44', value: 15 },
          { category: '45+', value: 6 },
        ],
        locationBreakdown: [
          { category: 'Singapore', value: 64 },
          { category: 'Malaysia', value: 14 },
          { category: 'Indonesia', value: 9 },
          { category: 'Other', value: 13 },
        ],
      },
      metricsVisibility: { gender: true, ageRange: true, location: true },
    },
    {
      id: 'soc-tiktok',
      platform: 'TikTok',
      handle: '@cynnthiamakes',
      followers: 12700,
      engagement: 6.8,
      stats: {
        genderBreakdown: [
          { category: 'Female', value: 71 },
          { category: 'Male', value: 29 },
        ],
        ageBreakdown: [
          { category: '18-24', value: 52 },
          { category: '25-34', value: 31 },
          { category: '35-44', value: 12 },
          { category: '45+', value: 5 },
        ],
        locationBreakdown: [
          { category: 'Singapore', value: 58 },
          { category: 'Malaysia', value: 17 },
          { category: 'Philippines', value: 11 },
          { category: 'Other', value: 14 },
        ],
      },
      metricsVisibility: { gender: true, ageRange: true, location: true },
    },
  ],
  portfolio: [
    {
      id: 'port-1',
      title: 'Summer Coffee Launch',
      platform: 'TikTok',
      type: 'Short-form video',
      thumbnailUrl: image('photo-1495474472287-4d71bcdd2085', 600, 450),
      visibility: 'Public',
      collaborationId: 'collab-1',
    },
    {
      id: 'port-2',
      title: 'GlowLab Skincare Routine',
      platform: 'Instagram',
      type: 'UGC sample',
      thumbnailUrl: image('photo-1522335789203-aabd1fc54bc9', 600, 450),
      visibility: 'Public',
      collaborationId: 'collab-2',
    },
    {
      id: 'port-3',
      title: 'Marina Bay Weekend Guide',
      platform: 'Instagram',
      type: 'Carousel',
      thumbnailUrl: image('photo-1523289333742-be1143f6b766', 600, 450),
      visibility: 'Public',
    },
  ],
  collaborations: [
    {
      id: 'collab-1',
      brand: 'Common Ground Coffee',
      brandLogoUrl: '/commongroundcoffee.png',
      campaign: 'Summer Coffee Launch',
      description: 'Launched Common Ground\'s new cold brew line with a short-form video series and in-cafe content day.',
      type: 'Paid campaign',
      status: 'Completed',
      startDate: '2026-06-01',
      endDate: '2026-06-14',
      visibility: 'Public',
      deliverables: [
        { id: 'del-1a', platform: 'Instagram Reel', contentUrl: 'https://instagram.com/reel/example1' },
        { id: 'del-1b', platform: 'Instagram Story', contentUrl: '' },
        { id: 'del-1c', platform: 'TikTok video', contentUrl: 'https://tiktok.com/@cynnthiamakes/video/example1' },
      ],
      // testimonial: 'Cynthia understood the brief quickly and delivered polished, on-brand content ahead of schedule.',
    },
    {
      id: 'collab-2',
      brand: 'GlowLab',
      brandLogoUrl: '/glowlab.png',
      campaign: 'Skincare Routine Launch',
      description: 'A 6-step morning routine series featuring GlowLab\'s new brightening serum, shot in Cynthia\'s own space for an authentic feel.',
      type: 'Gifted campaign',
      status: 'Completed',
      startDate: '2026-04-15',
      endDate: '2026-04-29',
      visibility: 'Public',
      deliverables: [
        { id: 'del-2a', platform: 'Instagram Reel', contentUrl: 'https://instagram.com/reel/example2' },
        { id: 'del-2b', platform: 'UGC video', contentUrl: '' },
      ],
      testimonial: '',
    },
    {
      id: 'collab-3',
      brand: 'Marina Bay Weekend',
      brandLogoUrl: '/marinabayweekend.png',
      campaign: 'Weekend Guide Feature',
      description: 'A weekend itinerary carousel highlighting local spots around Marina Bay for a tourism board campaign.',
      type: 'UGC',
      status: 'Completed',
      startDate: '2026-02-10',
      endDate: '',
      visibility: 'Public',
      deliverables: [{ id: 'del-3a', platform: 'Instagram Carousel', contentUrl: 'https://instagram.com/p/example3' }],
      testimonial: '',
    },
  ],
};
